import React, { useEffect, useRef, useState } from 'react'
import { API_URL } from '../../env'
import axios from 'axios'
import { Accordion, Col, Row } from 'react-bootstrap'
import { Fade, Zoom } from 'react-awesome-reveal'
import { ThreeCircles } from 'react-loader-spinner'
import { toast } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faCreditCard, faDownload, faEnvelope, faFileExcel, faFilePdf, faLandmark, faLocationDot, faPenClip, faPhone, faPlus, faRulerCombined, faUser } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Admin/AdminDiagnostic.css'
import AccordionItem from '../Utils/AccordionItem'
import Badge from '../Utils/Badge'
import Button from '../Utils/Button'
import Modal from '../Utils/Modal'
import InputSelect from '../Input/InputSelect'
import InputFile from '../Input/InputFile'
import { useNavigate } from 'react-router-dom'
import InputSwitch from '../Input/InputSwitch'
import InputSearch from '../Input/InputSearch'
import XLSX from 'xlsx-js-style'

function AdminDiagnostic({ adminRouter, setAdminRouterPrev, itemDisplay, diagnostics, getDiagnostics, customers, getCustomers, getPayments }) {

    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState(false)
    const [accordionIndex, setAccordionIndex] = useState(null)
    const [displayAddDiagnosticModal, setDisplayAddDiagnosticModal] = useState(false)
    const [diagnosticsDisplay, setDiagnosticsDisplay] = useState(diagnostics)
    const [search, setSearch] = useState("")

    const customerAddRef = useRef(null)
    const [customerAdd, setCustomerAdd] = useState(null)
    const [customerAddError, setCustomerAddError] = useState(null)
    const typeAddRef = useRef(null)
    const [typeAdd, setTypeAdd] = useState(null)
    const [typeAddError, setTypeAddError] = useState(null)
    const [addPDF, setAddPDF] = useState(false)
    const filePDFAddRef = useRef(null)
    const [filePDFAdd, setFilePDFAdd] = useState(null)
    const [filePDFAddError, setFilePDFAddError] = useState(null)
    const [addPayment, setAddPayment] = useState(false)

    const customerUpdateRef = useRef(null)
    const [customerUpdate, setCustomerUpdate] = useState(null)
    const [customerUpdateError, setCustomerUpdateError] = useState(null)
    const typeUpdateRef = useRef(null)
    const [typeUpdate, setTypeUpdate] = useState(null)
    const [typeUpdateError, setTypeUpdateError] = useState(null)
    const filePDFUpdateRef = useRef(null)
    const [filePDFUpdate, setFilePDFUpdate] = useState(null)
    const [filePDFUpdateError, setFilePDFUpdateError] = useState(null)

    const diagnosticsData = diagnostics
    const typeData = [
        { value: 'Loi Carrez', label: 'Loi Carrez' },
        { value: 'Loi Boutin', label: 'Loi Boutin' },
        { value: 'Diagnostic DPE', label: 'Diagnostic DPE' },
        { value: 'Diagnostic électricité', label: 'Diagnostic électricité' },
        { value: 'Diagnostic gaz', label: 'Diagnostic gaz' },
        { value: 'Diagnostic plomb', label: 'Diagnostic plomb' },
        { value: 'Diagnostic amiante', label: 'Diagnostic amiante' },
        { value: 'Diagnostic termites', label: 'Diagnostic termites' },
        { value: 'Diagnostic ERP', label: 'Diagnostic ERP' },
        { value: 'Audit énergétique', label: 'Audit énergétique' },
        { value: 'Audit énergétique consultatif', label: 'Audit énergétique consultatif' },
        { value: 'Diagnostic amiante avant travaux', label: 'Diagnostic amiante avant travaux' },
        { value: 'Diagnostic DPE avec mentions', label: 'Diagnostic DPE avec mentions' },
        { value: 'Diagnostic DPE conseil', label: 'Diagnostic DPE conseil' },
        { value: 'Diagnostic accessibilité', label: 'Diagnostic accessibilité' },
        { value: 'Plan côtés en 2D', label: 'Plan côtés en 2D' },
        { value: 'Plan élevés en 3D', label: 'Plan élevés en 3D' },
    ]
    const customerData = customers.map((item) => { return { value: item.id, label: item.firstname + " " + item.lastname } })

    useEffect(() => {

        displayRouterItem()

    }, [])


    useEffect(() => {

        autocompleteDiagnosticAdd()

    }, [customers, itemDisplay])

    useEffect(() => {

        setDiagnosticsDisplay(diagnostics)

    }, [diagnostics])

    function displayRouterItem() {

        if (itemDisplay === 'addDiagnostic') {
            setDisplayAddDiagnosticModal(true)
        } else if (itemDisplay !== "0") {
            setAccordionIndex(diagnostics.indexOf(diagnostics.find((item) => item.id === parseInt(itemDisplay))))
            window.scrollTo({ top: 230 + (60 * (diagnostics.indexOf(diagnostics.find((item) => item.id === parseInt(itemDisplay))) - 1)), behavior: 'instant' })
        }

    }

    function autocompleteDiagnosticAdd() {

        if (itemDisplay === 'addDiagnostic') {
            setCustomerAdd({ value: customers[0].id, label: customers[0].firstname + " " + customers[0].lastname })
            setCustomerAddError(false)
        }

    }

    function exportExcel() {

        const wb = XLSX.utils.book_new()
        let dataTitle = [
            { v: "E5M Diagnostics", s: { font: { name: "Brush Script MT", bold: true, sz: 20, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataHeader = [
            { v: "Date", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Status", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Type", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Payment", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Nom", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Email", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Téléphone", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
            { v: "Adresse", s: { font: { name: "Calibri", bold: true, sz: 16, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
        ]
        let dataBody = []
        diagnosticsDisplay.forEach((item) => {
            dataBody.push([
                { v: item.createdAt, s: { font: { name: "Calibri", sz: 12, }, fill: { type: 'pattern', pattern: 'solid', fgColor: { rgb: 'D5E0D2' }, bgColor: { rgb: 'D5E0D2' } } } },
                { v: item.status, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.type, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.payments[item.payments.length - 1] ? item.payments[item.payments.length - 1].amount + " (" + new Date(item.payments[item.payments.length - 1].updatedAt).toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' }) + ")" : "Impayé", s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.firstname + " " + item.customer.lastname, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.email, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.phone, s: { font: { name: "Calibri", sz: 12, } } },
                { v: item.customer.addressStreet + ", " + item.customer.addressZipcode + " " + item.customer.addressCity }
            ])
        })
        const ws = XLSX.utils.aoa_to_sheet([dataTitle, [], [], dataHeader, ...dataBody])
        ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: 7 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 7 } }]
        ws['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }]
        XLSX.utils.book_append_sheet(wb, ws, "E5M Diagnostics Sheet1")
        XLSX.writeFile(wb, "E5M Diagnostics Export (" + new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'numeric', day: 'numeric' }) + ").xlsx")

    }

    function addDiagnostic() {

        setIsLoading(true)
        var error = []
        var typeFormat = null
        if (!typeAddRef.current.selectValidation(typeAdd)) {
            error.push("Le type de diagnostic est incorrect")
        } else {
            typeFormat = typeAdd.map((item) => item.value)
        }
        var customerIdFormat = null
        if (!customerAddRef.current.selectValidation(customerAdd)) {
            error.push("Le client est incorrect")
        } else {
            customerIdFormat = customerAdd.value
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Ajout...")
            axios.post(API_URL + "diagnostic", {
                type: typeFormat,
                customerId: customerIdFormat,
            }).then((response) => {
                if (response.data.message === "DIAGNOSTIC_CREATED") {
                    toast.update(toastId, { render: "Diagnostic ajouté", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getDiagnostics()
                    getCustomers()
                    getPayments()
                    setDisplayAddDiagnosticModal(false)
                    setTypeAdd(null)
                    setTypeAddError(null)
                    setCustomerAdd(null)
                    setCustomerAddError(null)
                    setAddPDF(false)
                    setFilePDFAdd(null)
                    setFilePDFAddError(null)
                    setAddPayment(false)
                    if (addPDF) {
                        updateDiagnosticPDF(response.data.diagnosticId, customerIdFormat, filePDFAdd)
                    }
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CUSTOMER_NOT_FOUND") {
                        errorMessage = "Le client est introuvable"
                    } else if (errorMessage === "ERROR_DIAGNOSTIC_CREATION") {
                        errorMessage = "Erreur lors de la création du diagnostic"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    function updateDiagnostic(diagnosticId) {

        setIsLoading(true)
        const diagnostic = diagnostics.find((item) => item.id === diagnosticId)
        var error = []
        var typeFormat = null
        var customerIdFormat = null
        if (!typeUpdate && !customerUpdate) {
            error.push("Aucun changement détecté")
        } else {
            if (!typeUpdate) {
                typeFormat = typeUpdate.map((item) => item.value)
            } else if (!typeUpdateRef.current.selectValidation(typeUpdate)) {
                error.push("Le type de diagnostic est incorrect")
            } else {
                typeFormat = typeUpdate.map((item) => item.value)
            }
            if (!customerUpdate) {
                customerIdFormat = diagnostic.customer.id
            } else if (!customerUpdateRef.current.selectValidation(customerUpdate)) {
                error.push("Le client est incorrect")
            } else {
                customerIdFormat = customerUpdate.value
            }
        }
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Modification...")
            axios.put(API_URL + "diagnostic/" + diagnosticId, {
                type: typeFormat,
                customerId: customerIdFormat,
            }).then((response) => {
                if (response.data === "DIAGNOSTIC_UPDATED") {
                    toast.update(toastId, { render: "Diagnostic modifié", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getDiagnostics()
                    setTypeUpdate(null)
                    setTypeUpdateError(null)
                    setCustomerUpdate(null)
                    setCustomerUpdateError(null)
                    setAccordionIndex(null)
                }
                setIsLoading(false)
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_CUSTOMER_NOT_FOUND") {
                        errorMessage = "Le client est introuvable"
                    } else if (errorMessage === "ERROR_DIAGNOSTIC_UPDATE") {
                        errorMessage = "Erreur lors de la modification du diagnostic"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    function updateDiagnosticPDF(diagnosticId, customerId, filePDF) {

        setIsLoading(true)
        var error = []
        var filePDFFormat = filePDFUpdate
        if (filePDF) {
            filePDFFormat = filePDF
        }
        if (!filePDFUpdateRef.current.fileValidation(filePDFFormat)) {
            error.push("Le fichier PDF est incorrect")
        }
        const formData = new FormData()
        formData.append('filePDF', filePDFFormat)
        if (error.length > 0) {
            error.map((item) => toast.error(item))
            setIsLoading(false)
        } else {
            const toastId = toast.loading("Ajout du PDF...")
            axios.put(API_URL + 'diagnostic/' + diagnosticId + '/pdf', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (response.data === 'DIAGNOSTIC_PDF_UPDATED') {
                    toast.update(toastId, { render: "PDF ajouté au diagnostic", type: "success", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                    getDiagnostics()
                    setFilePDFUpdate(null)
                    setFilePDFUpdateError(null)
                    setIsLoading(false)
                    if (addPayment) {
                        setAdminRouterPrev(adminRouter)
                        navigate('/administration/payment/addPayment', { state: { diagnosticId: diagnosticId, customerId: customerId } })
                    }
                }
            }).catch((error) => {
                if (error.response) {
                    var errorMessage = error.response.data.message
                    if (errorMessage === "ERROR_DIAGNOSTIC_NOT_FOUND") {
                        errorMessage = "Le client est introuvable"
                    } else if (errorMessage === "ERROR_DIAGNOSTIC_UPDATE") {
                        errorMessage = "Erreur lors de la mise à jour du diagnostic"
                    }
                }
                toast.update(toastId, { render: errorMessage, type: "error", isLoading: false, closeButton: true, closeOnClick: true, autoClose: 5000 })
                setIsLoading(false)
            })
        }

    }

    return (

        <div id='adminDiagnostic'>
            <Fade direction={'left'} duration={500} triggerOnce={true}>
                <div className='adminBarButton'>
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => setDisplayAddDiagnosticModal(true)} />
                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faFileExcel} />} text={'Exporter'} rounded={true} onClick={() => exportExcel()} />
                    <InputSearch
                        type={'diagnostic'}
                        theme={'dark'}
                        search={search} setSearch={setSearch}
                        data={diagnosticsData}
                        results={diagnosticsDisplay} setResults={setDiagnosticsDisplay}
                        placeholder={'Rechercher par status, date, diagnostic ou client'}
                    />
                </div>
                <Modal
                    displayModal={displayAddDiagnosticModal}
                    setDisplayModal={setDisplayAddDiagnosticModal}
                    header={'Ajouter un diagnostic'}
                    body={
                        <>
                            <Zoom duration={500}>
                                <div>
                                    <InputSelect
                                        theme={'dark'}
                                        ref={customerAddRef}
                                        data={customerData}
                                        select={customerAdd} setSelect={setCustomerAdd}
                                        selectError={customerAddError} setSelectError={setCustomerAddError}
                                        icon={<FontAwesomeIcon icon={faUser} />}
                                        placeholder={"Client"}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={50}>
                                <div>
                                    <InputSelect
                                        theme={'dark'}
                                        ref={typeAddRef}
                                        data={typeData}
                                        select={typeAdd} setSelect={setTypeAdd}
                                        selectError={typeAddError} setSelectError={setTypeAddError}
                                        icon={<FontAwesomeIcon icon={faRulerCombined} />}
                                        placeholder={"Type de diagnostic"}
                                        multiple={true}
                                    />
                                </div>
                            </Zoom>
                            <Zoom duration={500} delay={100}>
                                <div>
                                    <InputSwitch
                                        value={addPDF} setValue={setAddPDF}
                                        label={"Ajouter directement le PDF pour ce diagnostic"}
                                    />
                                </div>
                            </Zoom>
                            {addPDF ?
                                <>
                                    <Zoom duration={500} delay={150}>
                                        <div>
                                            <InputFile
                                                theme={'dark'}
                                                ref={filePDFAddRef}
                                                file={filePDFAdd} setFile={setFilePDFAdd}
                                                fileError={filePDFAddError} setFileError={setFilePDFAddError}
                                                format={['pdf', 'PDF']}
                                                icon={<FontAwesomeIcon icon={faFilePdf} />}
                                                placeholder={'Ajouter le fichier PDF du diagnostic'}
                                            />
                                        </div>
                                    </Zoom>
                                    <Zoom duration={500} delay={200}>
                                        <div>
                                            <InputSwitch
                                                value={addPayment} setValue={setAddPayment}
                                                label={"Continuer avec la création du paiement pour ce diagnostic"}
                                            />
                                        </div>
                                    </Zoom>
                                </>
                                : null
                            }
                            <div id='adminInfoAddButton'>
                                {!isLoading ?
                                    <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => addDiagnostic()} />
                                    :
                                    <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                }
                            </div>
                        </>
                    }
                />
                <Accordion defaultActiveKey={accordionIndex} activeKey={accordionIndex}>
                    {diagnosticsDisplay.map((item, index) => {
                        return (
                            <AccordionItem
                                key={item.id}
                                indexKey={index}
                                index={accordionIndex}
                                setIndex={setAccordionIndex}
                                header={
                                    <>
                                        <Badge theme={item.status === 'En cours' ? 'blue' : item.status === 'Terminé' ? 'green' : 'red'} text={item.status} />
                                        {item.createdAt} - {item.type} ({item.customer.firstname} {item.customer.lastname})
                                    </>
                                }
                                body={
                                    <Row>
                                        <Col>
                                            <table className='adminInfo'>
                                                <tbody>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Créé le {item.createdAt}
                                                        </td>
                                                    </tr>
                                                    <tr className='adminInfoText'>
                                                        <td className='adminInfoTextIcon'>
                                                            <FontAwesomeIcon icon={faCalendar} />
                                                        </td>
                                                        <td>
                                                            Modifié le {item.updatedAt}
                                                        </td>
                                                    </tr>
                                                </tbody>

                                            </table>
                                            <InputSelect
                                                theme={'dark'}
                                                ref={customerUpdateRef}
                                                data={customerData}
                                                select={customerUpdate} setSelect={setCustomerUpdate}
                                                selectError={customerUpdateError} setSelectError={setCustomerUpdateError}
                                                icon={<FontAwesomeIcon icon={faUser} />}
                                                value={{ value: item.customer.id, label: item.customer.firstname + " " + item.customer.lastname }}
                                            />
                                            <InputSelect
                                                theme={'dark'}
                                                ref={typeUpdateRef}
                                                data={typeData}
                                                select={typeUpdate} setSelect={setTypeUpdate}
                                                selectError={typeUpdateError} setSelectError={setTypeUpdateError}
                                                icon={<FontAwesomeIcon icon={faRulerCombined} />}
                                                value={{ value: item.type, label: item.type }}
                                                multiple={true}
                                            />
                                            <div className='adminInfoUpdateButton'>
                                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPenClip} />} text={'Modifier'} rounded={true} onClick={() => updateDiagnostic(item.id)} />
                                            </div>
                                            {item.status === 'En cours' ?
                                                <Zoom duration={500}>
                                                    <div className='adminDiagnosticFile'>
                                                        <InputFile
                                                            theme={'dark'}
                                                            ref={filePDFUpdateRef}
                                                            file={filePDFUpdate} setFile={setFilePDFUpdate}
                                                            fileError={filePDFUpdateError} setFileError={setFilePDFUpdateError}
                                                            format={['pdf', 'PDF']}
                                                            icon={<FontAwesomeIcon icon={faFilePdf} />}
                                                            placeholder={'Ajouter le fichier PDF du diagnostic'}
                                                        />
                                                        <InputSwitch
                                                            value={addPayment} setValue={setAddPayment}
                                                            label={"Continuer avec la création du paiement pour ce diagnostic"}
                                                        />
                                                        <div className='adminDiagnosticAddFileButton'>
                                                            {!isLoading ?
                                                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPlus} />} text={'Ajouter'} rounded={true} onClick={() => updateDiagnosticPDF(item.id, item.customer.id, null)} />
                                                                :
                                                                <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                                            }
                                                        </div>
                                                    </div>
                                                </Zoom>
                                                : null
                                            }
                                            {item.status === 'Terminé' ?
                                                <Zoom duration={500}>
                                                    <div className='adminDiagnosticFile'>
                                                        <div className='adminDiagnosticFileButton'>
                                                            <Button theme={'primary'} icon={<FontAwesomeIcon icon={faFilePdf} />} text={'Ouvrir'} rounded={true} onClick={() => null} />
                                                            <Button theme={'primary'} icon={<FontAwesomeIcon icon={faDownload} />} text={'Télécharger'} rounded={true} onClick={() => null} />
                                                        </div>
                                                        <InputFile
                                                            theme={'dark'}
                                                            ref={filePDFUpdateRef}
                                                            file={filePDFUpdate} setFile={setFilePDFUpdate}
                                                            fileError={filePDFUpdateError} setFileError={setFilePDFUpdateError}
                                                            format={['pdf', 'PDF']}
                                                            icon={<FontAwesomeIcon icon={faFilePdf} />}
                                                            placeholder={'Modifier le fichier PDF'}
                                                        />
                                                        <div className='adminDiagnosticAddFileButton'>
                                                            {!isLoading ?
                                                                <Button theme={'dark'} icon={<FontAwesomeIcon icon={faPenClip} />} text={'Modifier'} rounded={true} onClick={() => updateDiagnosticPDF(item.id, item.customer.id, null)} />
                                                                :
                                                                <ThreeCircles visible={true} height={"40"} width={"40"} color={getComputedStyle(document.documentElement).getPropertyValue('--loaderDark')} />
                                                            }
                                                        </div>
                                                    </div>
                                                </Zoom>
                                                : null
                                            }
                                        </Col>
                                        <Col>
                                            <Zoom duration={500}>
                                                <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/customer/' + item.customer.id) }}>
                                                    <div className='adminCardTitle'>
                                                        <FontAwesomeIcon icon={faUser} className='adminCardTitleIcon' />
                                                        {item.customer.firstname}
                                                        <br />
                                                        {item.customer.lastname}
                                                    </div>
                                                    <table>
                                                        <tbody>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faLocationDot} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.addressStreet}, {item.customer.addressZipcode} {item.customer.addressCity}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.email}
                                                                </td>
                                                            </tr>
                                                            <tr className='adminCardText'>
                                                                <td className='adminCardTextIcon'>
                                                                    <FontAwesomeIcon icon={faPhone} />
                                                                </td>
                                                                <td>
                                                                    {item.customer.phone}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Zoom>
                                        </Col>
                                        <Col>
                                            {item.payments.map((itemPayment) => {
                                                return (
                                                    <Zoom key={itemPayment.id} duration={500} delay={100}>
                                                        <div className='adminCard' onClick={() => { setAdminRouterPrev(adminRouter); navigate('/administration/payment/' + itemPayment.id) }}>
                                                            <div className='adminCardTitle'>
                                                                <FontAwesomeIcon icon={faCreditCard} className='adminCardTitleIcon' />
                                                                <div className='adminCardTitleValue'>{itemPayment.amount}</div>
                                                            </div>
                                                            <table>
                                                                <tbody>
                                                                    <tr className='adminCardText'>
                                                                        <td className='adminCardTextIcon'>
                                                                            <FontAwesomeIcon icon={faLandmark} />
                                                                        </td>
                                                                        <td>
                                                                            <Badge theme={itemPayment.status === 'Non payé' ? 'grey' : itemPayment.status === 'En cours' ? 'blue' : itemPayment.status === 'Payé' ? 'green' : 'red'} text={itemPayment.status} />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </Zoom>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                }
                                animated={false}
                            />
                        )
                    })}
                </Accordion>
            </Fade>
        </div >

    )

}

export default AdminDiagnostic